import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { SecurityQuestion } from '../models/security-question.model';
import { finalize } from 'rxjs/operators';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],
  template:`
  <div class="login-card"  *ngIf="showSecurityQuestions">
    <!-- SECURITY QUESTIONS -->
      <div class="section-title">
        Set security questions
      </div>
      <!-- Question 1 -->
      <div class="question-block">
        <div class="question-row">
          <label class="question-label">{{ selectedQuestions[0]?.question }}?</label>
          <span class="refresh-icon"
            (click)="changeQuestion(0)">
            ↻
          </span>
        </div>
        <input class="input" [(ngModel)]="answers[0]">
      </div>

      <!-- Question 2 -->
      <div class="question-block">
        <div class="question-row">
          <label class="question-label">{{ selectedQuestions[1]?.question }}?</label>
            <span class="refresh-icon"
              (click)="changeQuestion(1)">
              ↻
            </span>
          </div>
          <input class="input" [(ngModel)]="answers[1]">
      </div>

      <!-- Question 3 -->
      <div class="question-block">
        <div class="question-row">
          <label class="question-label">{{ selectedQuestions[2]?.question }}?</label>
            <span class="refresh-icon"
              (click)="changeQuestion(2)">
              ↻
            </span>
          </div>
          <input class="input" [(ngModel)]="answers[2]">
      </div>

      <!-- BUTTONS -->
      <div class="btns">
        <button class="set-authorization-btn"
          (click)="saveSecurityAnswers()"
          [disabled]="isLoading || !answers[0] || !answers[1] || !answers[2]">
          <span *ngIf="!isLoading">Save</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>
      </div>
  </div>
  <div class="overlay" *ngIf="showErrorPopup">
    <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Close
          </button>
        </div>
    </div>
  </div>
  `
})
export class SetSecurityQuestionsPage implements OnInit{
  userId = '';
  whatsAppUrl = environment.whatsapp_url;
  isLoading = false;
  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService) {
    this.generateQuestions();
  }
  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('userId') ?? '';
    if (!this.userId) {
      this.errorMessage = 'Invalid link';
      this.showErrorPopup = true;
      this.showSecurityQuestions = false
      return;
    }
    this.loadSecurityQuestions();
  }
  loadSecurityQuestions() {
    this.authService
    .getSecurityQuestions(this.userId)
    .subscribe({
        next: response => {
          console.log(response);
          this.securityQuestions = response.securityQuestions.questions.$values;
          this.generateQuestions();
        },
        error: err => {
          this.showSecurityQuestions = false;
          if (err.status === 403) {
            this.router.navigateByUrl(
              '/setauthorizationpin/' + this.userId,
              { replaceUrl: true }
            );
            return;
          }
          this.errorMessage = err.error?.message ?? 'Unable to load security questions.';
          this.showErrorPopup = true;
        }
      },
    );
  }
  // =====================================================
  // ERROR
  // =====================================================
  errorMessage = '';
  showErrorPopup = false;
  closeErrorPopup() {
    window.location.href = this.whatsAppUrl;
  }
  // =====================================================
  // SECURITY QUESTIONS
  // =====================================================
  securityQuestions: SecurityQuestion[] = [];
  selectedQuestions: SecurityQuestion[] = [];
  securityAnswers = [];
  answers = ['', '', ''];
  showSecurityQuestions = true;
  generateQuestions() {
    const shuffled = [...this.securityQuestions]
      .sort(() => Math.random() - 0.5);
    this.selectedQuestions = shuffled.slice(0, 3);
  }
  changeQuestion(index: number) {
    const available = this.securityQuestions.filter(
      q => !this.selectedQuestions.includes(q)
    );
    if (!available.length) {
      return;
    }
    const random =
      available[Math.floor(Math.random() * available.length)];
    this.selectedQuestions[index] = random;
  }
  saveSecurityAnswers() {
    const questions = this.selectedQuestions.map((q, index) => ({
      questionId: q.id,
      answer: this.answers[index]
    }));
    this.isLoading = true;
    this.authService
    .postSecurityAnswers(this.userId, questions)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
      next: response => {
        this.router.navigateByUrl(
          '/setauthorizationpin/' + this.userId,
          { replaceUrl: true }
        );
      },
      error: err => {
        this.errorMessage = err.error?.message ?? 'Unable to save security questions.';
        this.showErrorPopup = true;
        this.showSecurityQuestions = false;
      }
    });
  }
}